
    <div style="width: 15%; float:left; overflow-y: scroll; height: 100%;">
      <ul>
        <li *ngFor="let mesh of meshes;let ind = index;">{{mesh.name}} <button (click)="showHideMesh(ind)">
        <ng-container *ngIf="meshVisibility[ind]">H</ng-container>
        <ng-container *ngIf="!meshVisibility[ind]">S</ng-container>
        </button></li>
      </ul>
    </div>
    <div id="modelWrapper" style="width: 85%; height: 100%; float:left;">
      <canvas id="model" width="200" height="200"></canvas>
    </div>
    <div class="menu-3d">
      <button></button>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/file.view.3d.component.ts.FileView3dComponent.html